/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowFailureRecipient } from './workflow-failure-recipient';
import {
    WorkflowFailureRecipientFromJSON,
    WorkflowFailureRecipientFromJSONTyped,
    WorkflowFailureRecipientToJSON,
    WorkflowFailureRecipientToJSONTyped,
} from './workflow-failure-recipient';

/**
 * 
 * @export
 * @interface WorkflowFailureRecipientListResponse
 */
export interface WorkflowFailureRecipientListResponse {
    /**
     * 
     * @type {Array<WorkflowFailureRecipient>}
     * @memberof WorkflowFailureRecipientListResponse
     */
    recipients: Array<WorkflowFailureRecipient>;
}

/**
 * Check if a given object implements the WorkflowFailureRecipientListResponse interface.
 */
export function instanceOfWorkflowFailureRecipientListResponse(value: object): value is WorkflowFailureRecipientListResponse {
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    return true;
}

export function WorkflowFailureRecipientListResponseFromJSON(json: any): WorkflowFailureRecipientListResponse {
    return WorkflowFailureRecipientListResponseFromJSONTyped(json, false);
}

export function WorkflowFailureRecipientListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowFailureRecipientListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'recipients': ((json['recipients'] as Array<any>).map(WorkflowFailureRecipientFromJSON)),
    };
}

export function WorkflowFailureRecipientListResponseToJSON(json: any): WorkflowFailureRecipientListResponse {
    return WorkflowFailureRecipientListResponseToJSONTyped(json, false);
}

export function WorkflowFailureRecipientListResponseToJSONTyped(value?: WorkflowFailureRecipientListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipients': ((value['recipients'] as Array<any>).map(WorkflowFailureRecipientToJSON)),
    };
}

